import { createRouterTransport } from "@connectrpc/connect";
import { CushionService } from "schema/gen/es/chiikipoint/cushion/v2/service_connect.js";
import {
  type GetAvailableTenantsRequest,
  GetAvailableTenantsResponse,
} from "schema/gen/es/chiikipoint/cushion/v2/service_pb";
import { getTenants } from "./config";

export const cushionServiceMockTransport = createRouterTransport(
  ({ service }) => {
    service(CushionService, {
      getAvailableTenants: (_: GetAvailableTenantsRequest) =>
        new GetAvailableTenantsResponse({
          tenants: getTenants(),
          store: {
            id: "0191fa54-bc14-7679-8d40-d8a31fa68a77",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            category: "コンビニ",
            iconUrl: "/misc/default-store-icon.png",
          },
        }),
    });
  },
);
